module.exports = __webpack_public_path__ + "static/img/11.2b50938.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/11.png
// module id = 7VhF
// module chunks = 0